import { removeCookie, removeStationsId, removeEmsId, removeToken } from '@/utils/auth'
export default {
  namespaced: true,
  state: {
    token: '',
    userName: '',
    language: '',
    permission: [],
    config: '',
    isCollapse: false,
    powerTip: false,
    profitTip: false,
    stationId: '',
    emsId: '',
    customerId: ''
  },
  getters: {
    getIsCollapse(state) {
      return state.isCollapse
    }
  },
  mutations: {
    setToken: (state, token) => {
      state.token = token
    },
    setUserName: (state, userName) => {
      state.userName = userName
    },
    setPermission: (state, permission) => {
      state.permission = permission
    },
    setLanguage: (state, language) => {
      state.language = language
    },
    setConfig: (state, config) => {
      state.config = config
    },
    setIsCollapse: (state, isCollapse) => {
      state.isCollapse = isCollapse
    },
    setPowerTip: (state, powerTip) => {
      state.powerTip = powerTip
    },
    setDescTip: (state, descTip) => {
      state.descTip = descTip
    },
    setProfitTip: (state, profitTip) => {
      state.profitTip = profitTip
    },
    setStationId: (state, stationId) => {
      state.stationId = stationId
    },
    setEmsId: (state, emsId) => {
      state.emsId = emsId
    },
    setCustomerId: (state, customerId) => {
      state.customerId = customerId
    }
  },
  actions: {
    /** @description 清除存储数据 */
    resetAll({ commit }) {
      commit('setToken', '')
      commit('setUserName', '')
      commit('setPermission', [])
      commit('setLanguage', '')
      commit('setConfig', '')
      commit('setIsCollapse', false)
      commit('setPowerTip', false)
      commit('setDescTip', false)
      commit('setProfitTip', false)
      commit('setStationId', '')
      commit('setEmsId', '')
      commit('setCustomerId', '')
    },
    /** @description 清除存储数据 */
    resetInfo() {
      removeToken('Token')
      removeCookie('UserName')
      removeCookie('Permission')
      removeCookie('config')
      removeCookie('isCollapse')
      removeCookie('setPowerTip')
      removeCookie('setDescTip')
      removeCookie('setProfitTip')
      removeStationsId('stationId')
      removeEmsId('emsId')
      removeCookie('customerId')
      removeCookie('strategyList')
    }
  }
}
